<div [attr.id]="chartId"></div>